module.exports = __webpack_public_path__ + "img/script-name-bg.8c1fa49c.png";